import React from 'react';
import { Link } from 'react-router-dom';

const steps = [
  {
    n: '1',
    title: 'Enter your dog',
    body: 'Enter your dog\'s registration number. We look it up and pre-fill the details, or enter manually and upload a pedigree.',
  },
  {
    n: '2',
    title: 'Official approval',
    body: 'Show officials review each entry. Once approved, the dog is placed in a class by age and sex and given a catalogue number.',
  },
  {
    n: '3',
    title: 'Digital catalogue',
    body: 'Browse the catalogue by class and sex, search by dog, registration or exhibitor, and follow grades and critiques during judging.',
  },
];

export default function HomePage() {
  return (
    <div>
      <section className="hero hero-refined" style={{ borderRadius: 'var(--r-lg)', margin: '0 0 var(--sp-6)' }}>
        <div className="container">
          <img
            src={`${process.env.PUBLIC_URL}/crc-logo.png`}
            alt="Cape Rottweiler Club"
            className="hero-logo"
          />
          <h1>Cape Rottweiler Club</h1>
          <p>
            Online show entries and the official digital catalogue. Look up your dog by
            registration number, confirm the details, and you are entered. Approved entries appear
            in the catalogue with grading and judge critiques.
          </p>
          <div className="flex" style={{ justifyContent: 'center' }}>
            <Link to="/enter" className="btn accent">Enter a dog</Link>
            <Link to="/shows" className="btn ghost" style={{ color: '#fff', borderColor: 'rgba(255,255,255,0.35)' }}>
              View shows
            </Link>
          </div>
        </div>
      </section>

      <div className="page-head">
        <p className="eyebrow">How it works</p>
        <h2 className="section-title">From entry to catalogue in three steps</h2>
      </div>

      <div className="grid cols-3">
        {steps.map((s) => (
          <div className="card feature-card" key={s.n}>
            <span className="feature-num">{s.n}</span>
            <h3>{s.title}</h3>
            <p className="muted">{s.body}</p>
          </div>
        ))}
      </div>

      <div className="card" style={{ marginTop: 'var(--sp-6)', display: 'flex', gap: 'var(--sp-5)', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'space-between' }}>
        <div style={{ minWidth: 260, flex: 1 }}>
          <h3 style={{ marginBottom: 'var(--sp-2)' }}>Ready to enter the next show?</h3>
          <p className="muted" style={{ margin: 0 }}>Entries are quick when your dog is already in our registry. Browse open shows and enter in minutes.</p>
        </div>
        <div className="flex">
          <Link to="/shows" className="btn ghost">See open shows</Link>
          <Link to="/enter" className="btn accent">Enter a dog</Link>
        </div>
      </div>
    </div>
  );
}
